import {bigBasicButton, bigPrimaryButtonLink} from 'app/client/ui2018/buttons';
import {mediaSmall, theme, vars} from 'app/client/ui2018/cssVars';
import {icon} from 'app/client/ui2018/icons';
import {input, styled} from 'grainjs';

// Note that the special settings remove the zip code number spinner
export const inputStyle = `
  color: ${theme.inputFg};
  background-color: ${theme.inputBg};
  font-size: ${vars.mediumFontSize};
  height: 42px;
  line-height: 16px;
  width: 100%;
  padding: 13px;
  border: 1px solid ${theme.inputBorder};
  border-radius: 3px;
  outline: none;

  &-invalid {
    color: ${theme.inputInvalid};
  }

  &[type=number] {
    -moz-appearance: textfield;
  }
  &[type=number]::-webkit-inner-spin-button,
  &[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: ${theme.inputPlaceholderFg};
  }
`;

export const billingInputDiv = styled('div', `
  color: ${theme.inputFg};
  background-color: ${theme.inputBg};
  font-size: ${vars.mediumFontSize};
  height: 42px;
  line-height: 16px;
  width: 100%;
  border: 1px solid ${theme.inputBorder};
  border-radius: 3px;
  outline: none;
  display: flex;
  overflow: hidden;

  &-invalid {
    color: ${theme.inputInvalid};
  }

  &[type=number] {
    -moz-appearance: textfield;
  }
  &[type=number]::-webkit-inner-spin-button,
  &[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: ${theme.inputPlaceholderFg};
  }
`);

export const cssLogoInlinePreview = styled('img', `
  aspect-ratio: 1;
  border: 1px solid ${theme.inputBorder};
  border-radius: 4px;
  padding: 2px;
  margin: 2px;
  height: 40px;
  cursor: pointer;
  object-fit: cover;
  &:hover {
    border-color: ${theme.accentBorder};
  }
`);


export const cssLogoPlacholderWrapper = styled('div', `
  aspect-ratio: 1;
  color: ${theme.inputPlaceholderFg};
  border: 1px solid ${theme.inputBorder};
  border-radius: 4px;
  padding: 2px;
  margin: 2px;
  height: 40px;
  cursor: pointer;
  display: grid;
  place-items: center;
  &:hover {
    border-color: ${theme.accentBorder};
  }
`);

export const cssLogoPlaceholder = styled(icon, `
  height: 60%;
  width: 60%;
  --icon-color: ${theme.inputPlaceholderFg};
`);

export const cssInnerInput = styled(input, `
  color: ${theme.inputFg};
  background-color: ${theme.inputBg};
  font-size: ${vars.mediumFontSize};
  line-height: 16px;
  padding: 13px;
  outline: none;
  border: none;
  flex: 1;
`);

export const billingInput = styled(input, inputStyle);

export const billingWrapper = styled('div', `
  overflow-y: auto;
`);

export const plansPage = styled('div', `
  margin: 60px 10%;
`);

export const plansContainer = styled('div', `
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 45px -1%;
`);

export const planInterval = styled('div', `
  display: inline-block;
  color: ${theme.lightText};
  font-weight: ${vars.headerControlTextWeight};
  font-size: ${vars.mediumFontSize};
  margin-left: 8px;
`);

export const summaryFeature = styled('div', `
  color: ${theme.text};
  margin: 24px 0 24px 20px;
  text-indent: -20px;
`);

export const summaryMissingFeature = styled('div', `
  color: ${theme.lightText};
  margin: 12px 0 12px 20px;
`);

export const summarySpacer = styled('div', `
  height: 28px;
`);

export const upgradeBtn = styled(bigPrimaryButtonLink, `
  width: 100%;
  margin: 15px 0 0 0;
  text-align: center;
`);

export const currentBtn = styled(bigBasicButton, `
  width: 100%;
  margin: 20px 0 0 0;
  cursor: default;
`);

export const billingPage = styled('div', `
  display: flex;
  max-width: 1000px;
  margin: auto;

  @media ${mediaSmall} {
    & {
      display: block;
    }
  }
`);

export const billingHeader = styled('div', `
  height: 32px;
  line-height: 32px;
  margin: 0 0 16px 0;
  color: ${theme.text};
  font-size: ${vars.xxxlargeFontSize};
  font-weight: ${vars.headerControlTextWeight};
`);

export const billingSubHeader = styled('div', `
  margin: 16px 0 24px 0;
  color: ${theme.text};
  font-size: ${vars.mediumFontSize};
  font-weight: bold;
`);

export const billingText = styled('div', `
  font-size: ${vars.mediumFontSize};
  color: ${theme.text};
`);

export const billingBoldText = styled(billingText, `
  font-weight: bold;
`);

export const billingHintText = styled('div', `
  font-size: ${vars.mediumFontSize};
  color: ${theme.lightText};
`);

// TODO: Adds a style for when the button is disabled.
export const billingTextBtn = styled('button', `
  font-size: ${vars.mediumFontSize};
  color: ${theme.controlFg};
  --icon-color: ${theme.controlFg};
  cursor: pointer;
  margin-left: 24px;
  background-color: transparent;
  border: none;
  padding: 0;
  text-align: left;
  display: block;
  &:hover {
    color: ${theme.controlHoverFg};
    --icon-color: ${theme.controlHoverFg};
  }
`);

export const billingActionButton = styled(billingTextBtn, `
  margin: 12px 0px;
  &-danger {
    color: ${theme.errorText};
    --icon-color: ${theme.errorText};
  }
  &-danger:hover {
    color: ${theme.errorTextHover};
    --icon-color: ${theme.errorTextHover};
  }
`);

export const billingIcon = styled(icon, `
  margin: 0 4px 2px 0;
`);

export const billingBadIcon = styled(icon, `
  background-color: ${theme.errorText};
  margin: 0 4px 2px 0;
`);

export const billingTickIcon = styled(icon, `
  background-color: ${theme.accentIcon};
  margin: 0 4px 2px 0;
`);

export const summaryItem = styled('div', `
  padding: 12px 0 26px 0;
`);

export const summaryFeatures = styled('div', `
  margin: 40px 0;
`);

export const summaryText = styled('span', `
  font-size: ${vars.mediumFontSize};
  color: ${theme.text};
`);

export const cssNameColumns = styled('div', `
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
`);

export const focusText = styled('span', `
  font-size: ${vars.mediumFontSize};
  color: ${theme.text};
  font-weight: bold;
`);

export const cardBlock = styled('div', `
  flex: 1 1 56%;
  margin: 60px;
  @media ${mediaSmall} {
    & {
      margin: 24px;
    }
  }
`);

export const displayFlex = styled('div', `
  display: flex;
`);

export const cssSummaryRow = styled(displayFlex, `
  margin-bottom: 0.6em;
  aling-items: flex-start;
`);

export const summaryHeader = styled(displayFlex, `
  margin-bottom: 16px;
`);

export const summaryBlock = styled('div', `
  flex: 1 1 44%;
  margin: 60px;
  @media ${mediaSmall} {
    & {
      margin: 24px;
    }
  }
`);

export const flexSpace = styled('div', `
  flex: 1 1 0px;
`);

export const paymentSubHeader = styled('div', `
  font-weight: ${vars.headerControlTextWeight};
  font-size: ${vars.xxlargeFontSize};
  color: ${theme.text};
  line-height: 60px;
`);

export const paymentField = styled('div', `
  display: block;
  flex: 1 1 0;
  margin: 4px 0;
  min-width: 120px;
`);

export const paymentFieldInfo = styled('div', `
  color: ${theme.lightText};
  margin: 10px 0;
`);

export const paymentFieldDanger = styled('div', `
  color: ${theme.dangerText};
  margin: 10px 0;
`);

export const paymentSpacer = styled('div', `
  width: 38px;
`);

export const paymentLabel = styled('label', `
  font-weight: ${vars.headerControlTextWeight};
  font-size: ${vars.mediumFontSize};
  color: ${theme.text};
  line-height: 38px;
`);

export const inputHintLabel = styled('div', `
  margin: 50px 5px 10px 5px;
`);

export const paymentBlock = styled('div', `
  margin: 0 0 20px 0;
`);

export const paymentRow = styled('div', `
  display: flex;
`);

export const paymentBtnRow = styled('div', `
  display: flex;
  margin-top: 30px;
  justify-content: flex-end;
`);

export const inputError = styled('div', `
  height: 16px;
  color: red;
`);

export const spinnerBox = styled('div', `
  margin: 60px;
  text-align: center;
`);

export const errorBox = styled('div', `
  margin: 60px 0;
`);

export const thanksBox = styled('div', `
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  margin-bottom: 20px;
  gap: 20px;
  align-items: center;
  justify-content: center;
  font-size: ${vars.largeFontSize};
  color: ${theme.text};
`);

export const cssTag = styled('span', `
  line-height: 0;
  margin-left: 4px;
  background-color: ${theme.accentIcon};
  padding: 2px 7px;
  border-radius: 7px;
  color: white;
  font-size: 0.9em;
  font-weight: 600;
`);

export const cssPointer = styled('span', `
  cursor: pointer;
`);

export const cssAssistantModel = styled('div', `
  position: relative;
  width: 500px;
  @media ${mediaSmall} {
    & {
      width: 100%;
      min-width: unset;
      padding: 24px 16px;
    }
  }
`);

export const cssCloseButton = styled('div', `
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  --icon-color: ${theme.modalCloseButtonFg};

  &:hover {
    background-color: ${theme.hover};
  }
`);

export const cssHeaderLine = styled('div', `
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
`);

export const cssAssistantCopy = styled('div', `
  line-height: 1.8;
`);

export const cssSubHeaderLine = styled(cssHeaderLine, `
  margin-top: 32px;
`);

export const cssTierPanel = styled('div', `
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${theme.widgetBorder};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  & + & {
    margin-top: 16px;
  }
  &:hover {
    border-color: ${theme.widgetActiveBorder};
  }
`);

export const cssLimit = styled('div', `
  display: flex;
  column-gap: 8px;
`);

export const cssTierPanelRight = styled('div', `
  display: flex;
`);

export const cssBold = styled('span', `
  font-weight: 600;
`);

export const cssButtons = styled('div', `
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`);
